import * as globals from '@wandb/weave/common/css/globals.styles';
import React, {useContext} from 'react';
import {useParams} from 'react-router';

import {Content} from '../../components/PageWithSidebar/PageWithSidebar.styles';
import NoAccessPage from '../../pages/NoAccessPage';
import {useModelsAccess} from '../../util/useModelsAccess';
import {AccountSelectorContext} from '../Search/SearchNav/AccountSelectorContextProvider';
import {InstrumentedLoader} from '../utility/InstrumentedLoader';
import {AgentDetailContent} from './AgentDetail/AgentDetailContent';
import {usePublicQueueAccess} from './hooks';
import {QueueDetailContent} from './QueueDetail/QueueDetailContent';
import {QueuesPage} from './Queues/QueuesPage';
import {WANDB_ENTITY_NAME} from './utils';

type LaunchContentParams = {
  agentId?: string;
  queueId?: string;
  entityName?: string;
};

/**
 * Used in home page with sidebar.
 * It is implied that user needs to be logged in to view these pages
 */
export const LaunchContent = () => {
  const {hasModelsAccess, isOrgMemberLoading} = useModelsAccess();
  const {hasPublicQueueAccess, isFeatureFlagLoading} = usePublicQueueAccess();

  const params = useParams<LaunchContentParams>();

  const {canSeeOrgInURL} = useContext(AccountSelectorContext);

  if (isOrgMemberLoading || isFeatureFlagLoading) {
    return <InstrumentedLoader name="launch-home-page" samplingRate={1.0} />;
  }

  if (!hasModelsAccess) {
    return <NoAccessPage contentKey={'noModelsAccess'} />;
  }

  const accessingWandbLaunchContent = params.entityName === WANDB_ENTITY_NAME;

  if (accessingWandbLaunchContent) {
    const canAccessWandbEntity = canSeeOrgInURL || hasPublicQueueAccess;
    if (!canAccessWandbEntity) {
      return <NoAccessPage contentKey={'loggedIn'} />;
    }
  }

  if (!canSeeOrgInURL && !accessingWandbLaunchContent) {
    return <NoAccessPage contentKey={'loggedIn'} />;
  }

  if (params.agentId != null) {
    return <AgentDetailContent />;
  }

  if (params.queueId != null) {
    // Render individual queue details page because we have the queueId to query for
    return <QueueDetailContent />;
  }

  return <QueuesPage />;
};

export const LaunchContentWrapper = () => {
  return (
    <Content background={globals.MOON_50}>
      <LaunchContent />
    </Content>
  );
};

export default LaunchContentWrapper;
